import { TEDCustomDateTimeDisplayer } from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode } from '../FormatterTypes';

class TEDDisplayDateTime extends TEDCustomDateTimeDisplayer {
  public static getInstance(): TEDDisplayDateTime {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayDateTime;

  public mode() {
    return TEDParseDateTimeMode.pdmYMDHM;
  }
}

export { TEDDisplayDateTime };
